<template>
	<div class="pa-2">
		<v-row
			dense
			class="mb-1">
			<v-spacer></v-spacer>
			<v-col cols="auto">
				<v-menu offsetY>
					<template v-slot:activator="{ on, attr }">
						<v-btn
							:disabled="loadingFetchEmployee || loadingFetchAttendance"
							:loading="loadingFetchEmployee || loadingFetchAttendance"
							v-on="on"
							v-bind="attr"
							small
							color="primary">
							<v-icon left>$add</v-icon>
							{{ $T('add') }}
						</v-btn>
					</template>
					<v-list dense>
						<v-list-item
							:disabled="
								![employeesTypes.applicants.value, employeesTypes.former.value].includes(
									employee.status,
								)
							"
							@click="startAdding(jobRecords.TemporaryAppointment.value)">
							{{ $T('roleTypes.TemporaryAppointment') }}
						</v-list-item>
						<v-list-item
							:disabled="
								![
									employeesTypes.applicants.value,
									employeesTypes.temporaries.value,
									employeesTypes.former.value,
								].includes(employee.status)
							"
							@click="startAdding(jobRecords.Stabilizing.value)">
							{{ $T('roleTypes.Stabilizing') }}
						</v-list-item>
						<v-list-item
							:disabled="
								[employeesTypes.applicants.value, employeesTypes.former.value].includes(
									employee.status,
								)
							"
							@click="startAdding(jobRecords.ChangingJobTitle.value)">
							{{ $T('roleTypes.ChangingJobTitle') }}
						</v-list-item>
						<v-list-item
							:disabled="
								[employeesTypes.applicants.value, employeesTypes.former.value].includes(
									employee.status,
								)
							"
							@click="startAdding(jobRecords.MovedToSection.value)">
							{{ $T('roleTypes.MovedToSection') }}
						</v-list-item>

						<v-list-item
							:disabled="
								[employeesTypes.applicants.value, employeesTypes.former.value].includes(
									employee.status,
								)
							"
							@click="startAdding(jobRecords.Breakup.value)">
							{{ $T('roleTypes.Breakup') }}
						</v-list-item>

						<v-divider></v-divider>

						<v-list-item
							:disabled="
								[employeesTypes.applicants.value, employeesTypes.former.value].includes(
									employee.status,
								)
							"
							@click="startAdding(jobRecords.ChangePermanentSystem.value)">
							{{ $T('roleTypes.ChangePermanentSystem') }}
						</v-list-item>
					</v-list>
				</v-menu>
			</v-col>
		</v-row>

		<bee-handy-table
			:headers="recordsHeaders"
			:items="recordsItem"
			dense
			zebra
			fixed-header
			:height="$vuetify.breakpoint.height - 155"
			hide-default-footer>
			<!-- <template v-slot:item.actions="{}">
				<div class="d-flex">
					<tooltip :text="$T('tooltips.preview')">
						<v-btn
							small
							icon>
							<v-icon
								size="20"
								color="preview">
								$view
							</v-icon>
						</v-btn>
					</tooltip>
					<tooltip :text="$T('tooltips.edit')">
						<v-btn
							small
							icon>
							<v-icon
								size="20"
								color="edit-color">
								$edit
							</v-icon>
						</v-btn>
					</tooltip>
					<tooltip :text="$T('tooltips.delete')">
						<v-btn
							small
							icon>
							<v-icon
								size="20"
								color="alert">
								$delete
							</v-icon>
						</v-btn>
					</tooltip>
				</div>
			</template> -->
		</bee-handy-table>

		<!-- main dialog -->
		<v-dialog
			v-model="dialog"
			persistent
			width="500"
			transition="dialog-transition">
			<v-card elevation="3">
				<v-card-title primary-title>
					{{ $T('addRecordDialog') }}
					<v-spacer></v-spacer>
					<v-btn
						@click="
							dialog = false;
							emptyTheDialog();
						"
						icon>
						<v-icon color="alert-color">mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<div>
						<v-stepper
							mobile-break-point="0"
							v-model="step"
							alt-labels
							flat>
							<v-stepper-header
								class="elevation-0"
								v-if="record.type !== jobRecords.ChangePermanentSystem.value">
								<v-stepper-step
									class="pa-1"
									:editable="step > 1"
									:complete="step > 1"
									step="1">
									{{ $T('addRecord.tabs.first') }}
								</v-stepper-step>

								<v-divider class="mt-4"></v-divider>

								<v-stepper-step
									class="pa-1"
									step="2">
									{{ $T('addRecord.tabs.attendance') }}
								</v-stepper-step>
							</v-stepper-header>

							<v-stepper-items>
								<!-- main content -->
								<v-stepper-content
									class="pa-0"
									step="1">
									<v-form class="pt-5">
										<!-- section -->
										<v-row
											class="mb-3"
											dense>
											<!-- old section -->
											<v-col class="flex-grow-1" v-if="showedInputs.oldSection">
												<v-autocomplete
													v-model="record.old.section"
													:items="employeeSections"
													disabled
													item-text="name"
													item-value="id"
													clearable
													dense
													outlined
													:label="
														showedInputs.newSection
															? $T('addRecord.oldSection')
															: $T('addRecord.section')
													"
													hide-details></v-autocomplete>
											</v-col>
											<!-- new section -->
											<v-col
												class="flex-grow-1"
												v-if="showedInputs.newSection">
												<v-autocomplete
													v-model="record.new.section"
													@click:prepend-inner="
														record.new.section = record.old.section
													"
													prepend-inner-icon="mdi-arrow-left-bold-box-outline"
													:items="sections"
													:loading="!sections.length"
													:disabled="!sections.length"
													item-text="name"
													item-value="id"
													clearable
													dense
													outlined
													:label="$T('addRecord.newSection')"
													hide-details></v-autocomplete>
											</v-col>
										</v-row>
										<!-- role -->
										<v-row
											class="mb-3"
											dense>
											<!-- old role -->
											<v-col
												class="flex-grow-1"
												v-if="showedInputs.oldRole">
												<v-autocomplete
													v-model="record.old.role"
													:items="[employeeRoles]"
													:loading="!employeeRoles"
													:disabled="!employeeRoles"
													item-text="name"
													item-value="id"
													clearable
													dense
													outlined
													:label="
														showedInputs.newRole
															? $T('addRecord.oldRole')
															: $T('addRecord.role')
													"
													hide-details></v-autocomplete>
											</v-col>
											<!-- new role -->
											<v-col
												class="flex-grow-1"
												v-if="showedInputs.newRole">
												<v-autocomplete
													v-model="record.new.role"
													@click:prepend-inner="record.new.role = record.old.role"
													prepend-inner-icon="mdi-arrow-left-bold-box-outline"
													:items="positions"
													:loading="!positions.length"
													:disabled="!positions.length"
													item-text="name"
													item-value="id"
													clearable
													dense
													outlined
													:label="$T('addRecord.newRole')"
													hide-details></v-autocomplete>
											</v-col>
										</v-row>
										<!-- date and cause -->
										<v-row
											class="mb-3"
											dense>
											<!-- date -->
											<v-col class="flex-grow-1">
												<bee-date-picker
													v-model="record.date"
													:input-label="$T('inputs.date')"
													:input-props="{
														outlined: true,
														dense: true,
														prependInnerIcon: '$calendar',
													}"
													menu-picker
													calendar
													no-title
													hide-details></bee-date-picker>
											</v-col>
											<!-- cause -->
											<v-col
												class="mt-3"
												cols="12">
												<v-text-field
													v-model="record.cause"
													outlined
													dense
													:label="$T('addRecord.cause')"
													hide-details>
												</v-text-field>
											</v-col>
										</v-row>
									</v-form>
								</v-stepper-content>

								<!-- attendance content -->
								<v-stepper-content
									class="pa-0"
									step="2">
									<v-form class="pt-5">
										<div class="d-flex align-end justify-space-between">
											<v-checkbox
												v-model="changingAttendance"
												:label="$T('addRecord.tabs.active')"
												dense
												hide-details
												class="mt-0"></v-checkbox>
										</div>
										<v-divider class="mt-2 mb-3"></v-divider>

										<v-row dense>
											<!-- old attendance -->
											<v-col
												cols="6"
												v-if="record.old.attendance">
												<!-- name -->
												<v-text-field
													:value="record.old.attendance.name"
													:disabled="!record.old.attendance"
													:loading="!record.old.attendance"
													dense
													readonly
													outlined
													hide-details></v-text-field>

												<!-- description -->
												<v-row
													v-if="record.old.attendance"
													dense
													class="mt-2">
													<!-- for hourly -->
													<v-col
														v-if="!record.old.attendance.isDaily"
														cols="12">
														دوام ساعي:
														<br />
														{{
															record.old.attendance.hourlySystems
																.weeklyHoursCount
														}}
														ساعة في الاسبوع
													</v-col>
													<!-- for normal -->
													<template
														v-else
														v-for="(item, i) in record.old.attendance
															.dailySystems">
														<v-col
															cols="5"
															:key="i + 'day'">
															{{ moment().day(i).format('dddd') }}
														</v-col>
														<v-col
															cols="7"
															:key="i + 'time'">
															{{
																item
																	? moment(item.startDate).format(
																			TIME_FORMAT,
																	  ) +
																	  '-' +
																	  moment(item.endDate).format(TIME_FORMAT)
																	: '-'
															}}
														</v-col>
													</template>
												</v-row>
											</v-col>

											<v-divider
												v-if="record.old.attendance"
												vertical></v-divider>

											<!-- new attendance -->
											<v-col cols="6">
												<!-- name -->
												<v-autocomplete
													v-model="record.new.attendance"
													:disabled="
														!changingAttendance ||
														!attendanceTypes ||
														!attendanceTypes.length
													"
													:loading="!attendanceTypes || !attendanceTypes.length"
													@click:prepend-inner="
														record.new.attendance = { ...record.old.attendance }
													"
													prepend-inner-icon="mdi-arrow-left-bold-box-outline"
													:items="attendanceTypes"
													return-object
													item-text="name"
													item-value="id"
													dense
													outlined
													hide-details></v-autocomplete>
												<!-- description -->
												<v-row
													v-if="record.new.attendance"
													dense
													class="mt-2">
													<!-- for hourly -->
													<v-col
														v-if="!record.new.attendance.isDaily"
														cols="12">
														دوام ساعي:
														<br />
														{{
															record.new.attendance.hourlySystems
																.weeklyHoursCount
														}}
														ساعة في الاسبوع
													</v-col>
													<!-- for normal -->
													<template
														v-else
														v-for="(item, i) in record.new.attendance
															.dailySystems">
														<v-col
															cols="5"
															:key="i + 'day'">
															{{ moment().day(i).format('dddd') }}
														</v-col>
														<v-col
															cols="7"
															:key="i + 'time'">
															{{
																item
																	? moment(item.startDate).format(
																			TIME_FORMAT,
																	  ) +
																	  '-' +
																	  moment(item.endDate).format(TIME_FORMAT)
																	: '-'
															}}
														</v-col>
													</template>
												</v-row>
											</v-col>
										</v-row>
									</v-form>
								</v-stepper-content>
							</v-stepper-items>
						</v-stepper>
					</div>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn
						v-if="step == 2"
						:loading="loadingAdding"
						:disabled="!formValid || loadingAdding"
						color="secondary"
						@click="addRecord">
						{{ $T('default-buttons.save') }}
					</v-btn>
					<v-btn
						v-else
						:disabled="!formValid"
						color="secondary"
						@click="step++">
						{{ $T('default-buttons.next') }}
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<!-- termination dialog -->
		<v-dialog
			v-model="terminationDialog"
			persistent
			width="450"
			transition="dialog-transition">
			<v-card elevation="3">
				<v-card-title primary-title>
					{{ $T('terminationDialog') }}
					<v-spacer></v-spacer>
					<v-btn
						@click="
							terminationDialog = false;
							emptyTheDialog();
						"
						icon>
						<v-icon color="alert-color">mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<v-form>
						<v-row dense>
							<!-- date -->
							<v-col cols="12">
								<bee-date-picker
									v-model="termination.date"
									:input-label="$T('inputs.date')"
									:input-props="{
										outlined: true,
										dense: true,
										prependInnerIcon: '$calendar',
									}"
									menu-picker
									calendar
									no-title
									hide-details></bee-date-picker>
							</v-col>

							<!-- cause -->
							<v-col
								class="mt-3"
								cols="12">
								<v-text-field
									v-model="termination.cause"
									outlined
									dense
									:label="$T('addRecord.cause')"
									hide-details>
								</v-text-field>
							</v-col>
						</v-row>
					</v-form>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<!-- <v-btn
						color="alt"
						icon
						outlined>
						<v-icon>mdi-paperclip</v-icon>
					</v-btn> -->
					<v-btn
						color="secondary"
						@click="terminate">
						{{ $T('default-buttons.save') }}
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
import moment, { DATE_FORMAT, TIME_FORMAT } from '@/utils/moment';
import { mapState } from 'vuex';
import { jobRecords, employeesTypes } from '@/utils/enum';
import { getEnumByValue } from '@/utils/helpers';

export default {
	name: 'JobRecords',

	props: {
		employee: { type: Object },
		employeeId: { type: String },
		loadingFetchEmployee: { type: Boolean },
	},

	data() {
		return {
			loadingFetchAttendance: true,
			loadingAdding: false,

			step: 1,
			dialog: false,
			terminationDialog: false,

			/* dialogs */
			changingAttendance: false,

			record: {
				old: {
					section: null,
					role: null,
					attendance: null,
				},
				new: {
					section: null,
					role: null,
					attendance: null,
				},
				date: null,
				cause: null,
				type: null,
			},

			termination: {
				date: null,
				cause: null,
			},

			showedInputs: {
				oldSection: true,
				newSection: true,
				oldRole: true,
				newRole: true,
			},
			/* end dialogs */

			recordsHeaders: [
				{
					text: this.$T('headers.record'),
					name: 'record',
					value: 'personalAction',
					noNotAvailableText: true,
					setValueExpr: (value) => getEnumByValue(value, jobRecords),
				},
				{
					text: this.$T('headers.date'),
					name: 'date',
					value: 'date',
					type: 'date',
					dateFormat: DATE_FORMAT,
				},
				{ text: 'من', name: 'from', value: 'from' },
				{ text: 'إلى', name: 'to', value: 'to' },
				{ text: this.$T('headers.details'), name: 'details', value: 'description' },
			],
			recordsItem: [],

			attendanceTypes: [],
			TIME_FORMAT,

			jobRecords,
			employeesTypes,
		};
	},

	computed: {
		formValid() {
			if (!this.record.date) return false;
			if (this.step === 1) {
				if (this.showedInputs.oldSection && !this.record.old.section) {
					return false;
				}
				if (this.showedInputs.oldRole && !this.record.old.role) {
					return false;
				}
				if (this.showedInputs.newSection && !this.record.new.section) {
					return false;
				}
				if (this.showedInputs.newRole && !this.record.new.role) {
					return false;
				}
			}
			if (this.step === 2) {
				if (!this.record.new.attendance && this.changingAttendance) return false;
			}
			return true;
		},
		employeeSections() {
			let section = this.employee?.section;
			section = this.sections.find((e) =>( e.id === section));
			if (!section) return;
			return [section];
		},
		employeeRoles() {
			const role = this.employee?.activeRole;
			if (!role) return;
			if (!this.positions || !this.positions.length) return;
			return this.positions.find((e) => e.id === role);
		},
		employeeAttendance() {
			const system = this.employee.activePermanentSystem;
			if (!system || !this.attendanceTypes) return;
			const permanentSystem = this.attendanceTypes.find((e) => e.id === system);
			return permanentSystem;
		},
		...mapState({
			sections: (state) => state.section.sections,
			positions: (state) => state.positions.positions,
		}),
	},

	methods: {
		startAdding(type) {
			if (type === this.jobRecords.Breakup.value) {
				this.terminationDialog = true;
				return;
			}

			this.initDialog(type);
		},
		initDialog(type) {
			this.showInput(type);
			this.initRecord(type);
			this.dialog = true;
		},
		showInput(type) {
			for (const key in this.showedInputs) {
				if (Object.hasOwnProperty.call(this.showedInputs, key)) {
					this.showedInputs[key] = false;
				}
			}

			switch (type) {
				case jobRecords.MovedToSection.value:
					this.showedInputs.oldSection = this.showedInputs.newSection = true;
					return;
				case jobRecords.EndAssignmentSection.value:
					this.showedInputs.oldSection = true;
					return;
				case jobRecords.SetSection.value:
					this.showedInputs.newSection = true;
					return;
				case jobRecords.Stabilizing.value:
					if (this.employeeSections?.length) this.showedInputs.oldSection = true;
					if (this.employeeRoles) this.showedInputs.oldRole = true;
					this.showedInputs.newSection = this.showedInputs.newRole = true;
					return;
				case jobRecords.TemporaryAppointment.value:
					if (this.employeeSections?.length) this.showedInputs.oldSection = true;
					if (this.employeeRoles) this.showedInputs.oldRole = true;
					this.showedInputs.newSection = this.showedInputs.newRole = true;
					return;
				case jobRecords.ChangingJobTitle.value:
					this.showedInputs.oldRole = this.showedInputs.newRole = true;
					return;
				case jobRecords.ChangePermanentSystem.value:
					this.showedInputs.oldSection = this.showedInputs.newSection = true;
					this.showedInputs.oldRole = this.showedInputs.newRole = true;
			}
		},
		initRecord(type) {
			this.emptyTheDialog();

			this.record.type = type;
			this.record.old.attendance = this.employeeAttendance;

			if (!this.employeeAttendance) this.changingAttendance = true;

			if (this.employeeSections?.length) this.record.old.section = this.employeeSections[0].id;
			if (this.employeeRoles) this.record.old.role = this.employeeRoles.id;
			this.record.date = new Date().toISOString().slice(0, 10);

			if (jobRecords.ChangePermanentSystem.value === type) {
				this.step = 2;
			}

			// switch (type) {
			// 	case jobRecords.MovedToSection.value:
			// 		this.record.old.section = this.employeeSections[0].id;
			// 		return;
			// 	case jobRecords.EndAssignmentSection.value:
			// 		return;
			// 	case jobRecords.SetSection.value:
			// 		return;
			// 	case jobRecords.Stabilizing.value:
			// 		if (this.employeeSections?.length) this.record.old.section = this.employeeSections[0].id;
			// 		if (this.employeeRoles) this.record.old.role = this.employeeRoles.id;
			// 		return;
			// 	case jobRecords.TemporaryAppointment.value:
			// 		return;
			// 	case jobRecords.ChangingJobTitle.value:
			// 		this.record.old.role = this.employeeRoles?.id;
			// 		return;
			// 	case jobRecords.ChangePermanentSystem.value:
			// 		this.step = 2;
			// 		this.record.old.section = this.record.new.section = this.employeeSections[0].id;
			// 		this.record.old.role = this.record.new.role = this.employeeRoles?.id;
			// 		this.record.date = new Date().toISOString().slice(0, 10);
			// }
		},
		emptyTheDialog() {
			this.step = 1;
			this.changingAttendance = false;

			this.record = {
				old: {
					section: null,
					role: null,
					attendance: null,
				},
				new: {
					section: null,
					role: null,
					attendance: null,
				},
				date: null,
				cause: null,
			};

			this.termination = {
				date: null,
				cause: null,
			};
		},

		addRecord() {
			const props = {
				employeeId: this.employeeId,
				date: this.record.date,
				description: this.record.cause,
			};

			const requests = [];

			if (this.record.type === this.jobRecords.TemporaryAppointment.value) {
				requests.push(
					this.$store.dispatch('record/addRecord', {
						...props,
						personalAction: this.jobRecords.TemporaryAppointment.value,
					}),
				);
				if (this.record.old.section !== this.record.new.section)
					requests.push(
						this.$store.dispatch('record/addRecord', {
							...props,
							personalAction: this.record.old.section
								? this.jobRecords.MovedToSection.value
								: this.jobRecords.SetSection.value,
							idFrom: this.record.old.section,
							idTo: this.record.new.section,
						}),
					);
				if (this.record.old.role !== this.record.new.role)
					requests.push(
						this.$store.dispatch('record/addRecord', {
							...props,
							personalAction: this.jobRecords.ChangingJobTitle.value,
							idFrom: this.record.old.role,
							idTo: this.record.new.role,
						}),
					);
			}

			if (this.record.type === this.jobRecords.Stabilizing.value) {
				requests.push(
					this.$store.dispatch('record/addRecord', {
						...props,
						personalAction: this.jobRecords.Stabilizing.value,
					}),
				);
				if (this.record.old.section !== this.record.new.section)
					requests.push(
						this.$store.dispatch('record/addRecord', {
							...props,
							personalAction: this.record.old.section
								? this.jobRecords.MovedToSection.value
								: this.jobRecords.SetSection.value,
							idFrom: this.record.old.section,
							idTo: this.record.new.section,
						}),
					);
				if (this.record.old.role !== this.record.new.role)
					requests.push(
						this.$store.dispatch('record/addRecord', {
							...props,
							personalAction: this.jobRecords.ChangingJobTitle.value,
							idFrom: this.record.old.role,
							idTo: this.record.new.role,
						}),
					);
			}

			if (this.record.type === this.jobRecords.MovedToSection.value) {
				requests.push(
					this.$store.dispatch('record/addRecord', {
						...props,
						personalAction: this.jobRecords.MovedToSection.value,
						idFrom: this.record.old.section,
						idTo: this.record.new.section,
					}),
				);
			}

			if (this.record.type === this.jobRecords.ChangingJobTitle.value) {
				requests.push(
					this.$store.dispatch('record/addRecord', {
						...props,
						personalAction: this.jobRecords.ChangingJobTitle.value,
						idFrom: this.record.old.role,
						idTo: this.record.new.role,
					}),
				);
			}

			if (
				this.record.new.attendance &&
				this.record.new.attendance.id !== this.record.old.attendance?.id
			)
				requests.push(
					this.$store.dispatch('record/addRecord', {
						...props,
						personalAction: jobRecords.ChangePermanentSystem.value,
						idFrom: this.record.old.attendance?.id,
						idTo: this.record.new.attendance.id,
					}),
				);

			this.loadingAdding = true;
			Promise.all(requests)
				.then((res) => {
					this.fetchAllRecords();
					this.$emit('fetch-employee');
					this.$eventBus.$emit('show-snackbar', 'تم التعديل', { done: true });
					this.dialog = false;
				})
				.catch(() => {
					this.$eventBus.$emit('show-snackbar', 'حدث خطأ ما', { error: true });
				})
				.finally(() => {
					this.loadingAdding = false;
				});
		},
		terminate() {
			this.loadingTerminate = true;
			this.$store
				.dispatch('record/addRecord', {
					employeeId: this.employeeId,
					date: this.termination.date,
					description: this.termination.cause,
					personalAction: jobRecords.Breakup.value,
				})
				.then((res) => {
					this.fetchAllRecords();
					this.$emit('fetch-employee');
					this.$eventBus.$emit('show-snackbar', 'تم التعديل', { done: true });
					this.terminationDialog = false;
				})
				.catch(() => {
					this.$eventBus.$emit('show-snackbar', 'حدث خطأ ما', { error: true });
				})
				.finally(() => {
					this.loadingTerminate = false;
				});
		},

		fetchAllRecords() {
			this.loadingRecords = true;
			this.$store
				.dispatch('record/getEmployeeRecords', { id: this.employeeId })
				.then((res) => {
					this.recordsItem = res;
				})
				.catch(() => {
					this.$eventBus.$emit('show-snackbar', 'حدث خطأ ما', { error: true });
				})
				.finally(() => {
					this.loadingRecords = false;
				});
		},

		fetchAttendanceTypes() {
			this.loadingFetchAttendance = true;
			this.$store
				.dispatch('attendance/fetchAttendanceTypes')
				.then((res) => {
					this.attendanceTypes = res;
				})
				.finally(() => {
					this.loadingFetchAttendance = false;
				});
		},
		moment,
	},

	mounted() {
		this.fetchAttendanceTypes();
		this.fetchAllRecords();
	},
};
</script>
